import BillsServices from '../../services/BillsServices'
import FileServices from "@/services/FileServices";
import pl from "vue2-datepicker/locale/es/pl";

const types = {
  GET_BILLS: '@BILLS/GET_BILLS',
  GET_BILLS_PAGE: '@BILLS/GET_BILLS_PAGE',
  GET_INVOICES: '@BILLS/GET_INVOICES',
  GET_INVOICE: '@BILLS/GET_INVOICE',
  GET_INVOICE_DETAIL: '@BILLS/GET_INVOICE_DETAIL',
  GET_INVOICE_NO: '@BILLS/GET_INVOICE_NO',
  GET_INVOICE_CHART: '@BILLS/GET_INVOICE_CHART',
  GET_INVOICE_MANAGER: '@BILLS/GET_INVOICE_MANAGER',
  GET_DATE_LIST : '@BILLS/GET_DATE_LIST',
  GET_SERIES_LIST : '@BILLS/GET_SERIES_LIST',
  GET_API_URL : '@BILLS/GET_API_URL',
  GET_SEARCH_PARAM : '@BILLS/GET_SEARCH_PARAM'
}

export {
  types as billsTypes
}

export default {
  namespaced: true,
  state: {
    bills: [],
    salesSearch: {
      loaded: false
      , pageNo: 1
      , searchText: ''
      , category: 'all'
      , pageSize: 20
      , startMonth: ''
      , endMonth: ''
    },
    manager: {
      employeeName : ''
      , employeeTel : ''
      , employeeEmail : ''
    },
    invoice: {},
    dateList: [],
    invoiceDetail: [],
    apiUrl : '',
    seriesList: [],
    pagingDTO : {
      pageNo : 0,
      size : 20,
      startIndex : 0,
      totalCount : 0
    },
    invoices: {
      invoices: [],
      remainAmountByKrw : 0,
      totalTradeAmountByKrw : 0
    },
    invoiceNo: '',
    chartData: [],
   // chartFilter: []

  },

  getters: {
    salesSearch: (state) => {
      return state.salesSearch
    },
    bills: (state) => {
      return state.bills
    },
    pagingDTO: (state) => {
      return state.pagingDTO
    },
    invoices: (state) => {
      return state.invoices
    },
    invoice: (state) => {
      return state.invoice
    },
    chartData: (state) => {
      return state.chartData
    },
    manager: (state) => {
      return state.manager
    },
    dateList: (state) => {
      return state.dateList
    },
    seriesList: (state) => {
      return state.seriesList
    },
    invoiceNo : (state) => {
      return state.invoiceNo
    },
    invoiceDetail : (state) => {
      return state.invoiceDetail
    },
    apiUrl : (state) => {
      return state.apiUrl
    }

  },

  mutations: {
    [types.GET_SEARCH_PARAM] (state, payload) {
      state.salesSearch = payload.salesSearch
    },
    [types.GET_BILLS] (state, payload) {
      state.bills = payload.bills
    },
    [types.GET_BILLS_PAGE] (state, payload) {
      state.pagingDTO = payload.pagingDTO
    },
    [types.GET_INVOICES] (state, payload) {
      state.invoices = payload.invoices
    },
    [types.GET_INVOICE] (state, payload) {
      state.invoice = payload.invoice
    },
    [types.GET_INVOICE_CHART] (state, payload) {
      state.chartData = payload.chartData
    },
    [types.GET_INVOICE_MANAGER] (state, payload) {
      state.manager = payload.manager
    },
    [types.GET_DATE_LIST] (state, payload) {
      state.dateList = payload.dateList
    },
    [types.GET_SERIES_LIST] (state, payload) {
      state.seriesList = payload.seriesList
    },
    [types.GET_INVOICE_NO] (state, payload) {
      state.invoiceNo = payload.invoiceNo
    },
    [types.GET_INVOICE_DETAIL] (state, payload) {
      state.invoiceDetail = payload.invoiceDetail
    },
    [types.GET_API_URL] (state, payload) {
      state.apiUrl = payload.apiUrl
    }
  },

  actions: {
    setSalesParam( {commit}, payload) {
      commit(types.GET_SEARCH_PARAM, { salesSearch: payload })
    },
    async getBills ({ commit }, payload) {
      const { companyCode, empNo, pageNo, size, searchText, orderCol, desc ,jobTitleCode,empAuthDept, category, startMonth, endMonth } = payload
      const response = await BillsServices.getBills({
        companyCode, empNo, pageNo, size, searchText, orderCol, desc, jobTitleCode,empAuthDept, category, startMonth, endMonth
      })
      commit(types.GET_BILLS, { bills: response.data.resultData.bills })
      commit(types.GET_BILLS_PAGE, { pagingDTO: response.data.resultData.pagingDTO })
      return response.data.resultData
    },
    async getInvoices({commit}, payload) {
      const { companyCode, currentMonth, customerCode, deptCode, pageNo, size, category } = payload
      const response = await BillsServices.getInvoices({
        companyCode, currentMonth, customerCode, deptCode, pageNo, size, category
      })
      commit(types.GET_INVOICES, { invoices: response.data.resultData })
      // commit(types.GET_INVOICE_NO, { invoiceNo: response.data.resultData.invoices[0].invoiceNo })
      commit(types.GET_DATE_LIST, { dateList: response.data.resultData.dateList })
      return response.data.resultData
    },
    async getInvoicesGetChartData({commit}, payload) {
      const { companyCode, customerCode, deptCode, endMonth, startMonth } = payload
      const response = await BillsServices.getInvoicesGetChartData({
        companyCode, customerCode, deptCode, endMonth, startMonth
      })
      commit(types.GET_INVOICE_CHART, { chartData: response.data.resultData.chartData })
      commit(types.GET_SERIES_LIST, { seriesList: response.data.resultData.seriesList })

      return response.data.resultData
    },
    async getCustomerBillUser({commit}, payload) {
      const { customerDeptCode, customerCode } = payload
      const response = await BillsServices.getCustomerBillUser({
        customerDeptCode, customerCode
      })
      commit(types.GET_INVOICE_MANAGER, { manager: response.data.resultData })
      return response.data.resultData
    },
    setInvoiceDetail({commit}, payload) {
      commit(types.GET_INVOICE, { invoice: payload })
    },
    async resendEmail({commit}, invoiceNo) {
      const response = await BillsServices.resendEmail(invoiceNo)
      return response.data.resultData
    },

    async getInvoicesWithInvoiceNo({commit}, payload) {
      const response = await BillsServices.getInvoicesWithInvoiceNo(payload)
      commit(types.GET_INVOICE_DETAIL, { invoiceDetail: response.data.resultData })
      return response.data.resultData
    },
    async openDownLoadBill({commit}, payload, empNo) {
      const response = await BillsServices.getJspUrl(payload)
      commit(types.GET_API_URL, { apiUrl: response.data.resultData })
      let url = response.data.resultData + '/api/v1/billPdf'

      let form = document.createElement("form");
      form.setAttribute("charset", "UTF-8");
      form.setAttribute("method", "Post");  //Post 방식
      form.setAttribute("action", "/user/signup"); //요청 보낼 주소
      let hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", "invoiceNo");
      hiddenField.setAttribute("value", payload.invoiceNo);
      form.appendChild(hiddenField);
      hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", "companyCode");
      hiddenField.setAttribute("value", payload.companyCode);
      form.appendChild(hiddenField);
      document.body.appendChild(form);

      window.open('about:blank','payviewer','width=500,height=500');

      form.action = url;
      form.target ="payviewer";
      form.method ="post";
      form.submit();

    },
    async getCSVDownLoad({commit}, payload){
      await FileServices.getCSVFile(payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/bills.js